import { render, staticRenderFns } from "./new.blog-tag.page.vue?vue&type=template&id=7cf0e3c5&"
import script from "./new.blog-tag.page.vue?vue&type=script&lang=js&"
export * from "./new.blog-tag.page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports